// extracted by mini-css-extract-plugin
export var addressFields = "_mi-0";
export var animationContainer = "_mi-1";
export var footer = "_mi-2";
export var lineItems = "_mi-3";
export var modalContent = "_mi-4";
export var orderName = "_mi-5";
export var strong = "_mi-6";
export var warning = "_mi-7";